<template>
    <ChangePassword data-cy="myPasswordTabContent"></ChangePassword>
</template>

<script>
import ChangePassword from '@components/ChangePassword';

export default {
    components: {
        ChangePassword
    }
};
</script>
